const scipDelinquencyReport = {
  label: "SCIP Delinquency Report (New)",
  name: "scipDelinquencyReport",
  parameters: [
    {
      name: "taxYear",
      label: "Tax year",
      type: "year",
      defaultValue: "2025",
    },
    {
      name: "countyId",
      label: "County",
      type: "dbfield",
      db: "scip",
      table: "County",
      keyField: "CountyId",
      valueField: "Name",
      fields: ["County.CountyId", "County.Name"],
      distinct: true,
      join: {
        Parcel: "CountyId",
      },
      sort: {
        Name: "asc",
      },
    },
    {
      name: "districtId",
      label: "District",
      type: "dbfield",
      db: "scip",
      table: "District",
      keyField: "DistrictId",
      valueField: "DistrictName",
      sort: {
        DistrictName: "asc",
      },
      dependsOn: "countyId",
    },
  ],
};

export default scipDelinquencyReport;
